import QuickOrderPage from "~/components/_/quick-order/index.vue";

var quickOrderApplication = new Vue({
    el: "#pages-quick-order-order-by-name-content",
    components: { QuickOrderPage }
});
